import { initializeApp } from "firebase/app";

import { getFirestore } from "@firebase/firestore";
import { getAuth } from "@firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyA5xf6i16amzwqBIedZY5KmKnR1unsuxf4",
  authDomain: "docs-13d5a.firebaseapp.com",
  projectId: "docs-13d5a",
  storageBucket: "docs-13d5a.appspot.com",
  messagingSenderId: "775578172342",
  appId: "1:775578172342:web:76fd8a60dd19fd5327df17"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const firestore = getFirestore(app);
const auth = getAuth(app);

export { firestore, auth };
